<template>
  <div class="locale-changer">
    <v-menu v-model="menuOpen" :offset="4">
      <template v-slot:activator="{ props }">
        <button
          type="button"
          class="lang-trigger"
         
          v-bind="props"
        >
          <img
            v-if="currentLocale"
            :src="getImgUrl(currentLocale)"
            alt="language"
            class="lang-flag"
          />
          <span v-else class="lang-placeholder" />
          <v-icon
            class="lang-arrow"
            :class="{ 'lang-arrow--open': menuOpen }"
          >mdi-menu-down</v-icon>
        </button>
      </template>
      <v-list class="lang-menu" density="compact">
        <v-list-item
          v-for="locale in resolvedLocales"
          :key="locale"
          :class="{ 'lang-item--active': locale === currentLocale }"
          @click="selectLocale(locale)"
        >
          <img
            :src="getImgUrl(locale)"
            alt="language"
            class="lang-flag"
          />
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'GlobalLanguageSelector',
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    locales: {
      type: Array,
      default: null,
    },
    applyImmediately: {
      type: Boolean,
      default: true,
    },
    flagOverrides: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      menuOpen: false,
      internalLocale: this.modelValue || this.$i18n.locale,
    }
  },
  computed: {
    currentLocale() {
      return this.modelValue !== null ? this.modelValue : this.internalLocale
    },
    resolvedLocales() {
      return this.locales && this.locales.length ? this.locales : this.$i18n.availableLocales
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal !== null) {
        this.internalLocale = newVal
      }
    },
  },
  methods: {
    getImgUrl(lang) {
      const asset = this.flagOverrides[lang] || lang
      return require('@/assets/' + asset + '.webp')
    },
    selectLocale(locale) {
      this.internalLocale = locale
      this.$emit('update:modelValue', locale)
      this.$emit('locale-changed', locale)
      if (this.applyImmediately) {
        this.$i18n.locale = locale
        localStorage.setItem('locale', locale)
      }
    },
  },
}
</script>

<style scoped>
.lang-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0;
  padding: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
}

.lang-flag {
  width: 40px;
  height: auto;
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.lang-placeholder {
  width: 40px;
  height: 27px;
  display: block;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 2px;
}

.lang-arrow {
  font-size: 20px !important;
  color: rgba(0, 0, 0, 0.54) !important;
  margin-left: -2px;
  transform: rotate(90deg);
  transition: transform 0.2s ease;
}

/* Defeat global unscoped .mdi-menu-down::before rules from Registration.vue. */
.lang-arrow.mdi-menu-down::before {
  margin-left: 0 !important;
}

.lang-arrow--open {
  transform: rotate(0deg);
}

.lang-menu {
  padding: 8px 0;
}

.lang-item--active {
  background-color: rgba(118, 184, 66, 0.12);
}
</style>
